export const BillableService = {
    getData() {
        return {
            division: '',
            name: '',
            labourBurden: 0,
            billableRate: 0,
            profit: 0,
            mark_up_per: 0,
            billableTime: 0,
            unBillableTime: 0,
            vacatiomStatTime: 0,
            eosTime: 0,
            salesTime: 0,
            sickTime: 0,
            totalHours: 0,
            unBillableTimePer: 0,
            profitthisPP: 0,
            lossVsBillable: 0,
            lossVsLB: 0,
            billableType: '',
            unbillableTimeLossThisPP: 0,
            eosTimeLossthisPP: 0,
            profitUnbillableAndEosthisPP: 0,

        }


    },
    isRenderableRow(row) {
        if (!row) {
            return false;
        }

        const hasLabelValue = [row.division, row.name, row.billableType].some(
            (value) => typeof value === 'string' && value.trim() !== ''
        );

        if (hasLabelValue) {
            return true;
        }

        const numericFields = [
            'labourBurden',
            'billableRate',
            'profit',
            'mark_up_per',
            'billableTime',
            'unBillableTime',
            'vacatiomStatTime',
            'eosTime',
            'salesTime',
            'sickTime',
            'totalHours',
            'unBillableTimePer',
            'profitthisPP',
            'lossVsBillable',
            'lossVsLB',
            'unbillableTimeLossThisPP',
            'eosTimeLossthisPP',
            'profitUnbillableAndEosthisPP'
        ];

        return numericFields.some((field) => {
            const numericValue = Number(row[field]);
            return !Number.isNaN(numericValue) && numericValue !== 0;
        });
    },
    GetCal(totalFieldOpearation, element, unBillableTimePer, billableType, division) {
    
        
        return {
            labourBurden: totalFieldOpearation.labourBurden + parseFloat(element.labourBurden),
            billableRate: totalFieldOpearation.billableRate + parseFloat(element.billableRate),
            profit: totalFieldOpearation.profit + parseFloat(element.profit),
            // mark_up_per: totalFieldOpearation.mark_up_per + (element.mark_up_per != null) ? parseFloat(element.mark_up_per) : 0,
            mark_up_per: totalFieldOpearation.mark_up_per +( (element.mark_up_per != null) ? parseFloat(element.mark_up_per) : 0),
            billableTime: totalFieldOpearation.billableTime + parseFloat(element.billableTime),
            unBillableTime: totalFieldOpearation.unBillableTime + parseFloat(element.unBillableTime),
            vacatiomStatTime: totalFieldOpearation.vacatiomStatTime + parseFloat(element.vacatiomStatTime),
            eosTime: totalFieldOpearation.eosTime + parseFloat(element.eosTime),
            salesTime: totalFieldOpearation.salesTime + parseFloat(element.salesTime),
            sickTime: totalFieldOpearation.sickTime + parseFloat(element.sickTime),
            totalHours: totalFieldOpearation.totalHours + parseFloat(element.totalHours),
            unBillableTimePer: totalFieldOpearation.unBillableTimePer + parseFloat(unBillableTimePer),
            profitthisPP: totalFieldOpearation.profitthisPP + parseFloat(element.profitthisPP),
            lossVsBillable: totalFieldOpearation.lossVsBillable + parseFloat(element.lossVsBillable),
            lossVsLB: totalFieldOpearation.lossVsLB + parseFloat(element.lossVsLB),
            name: '',
            billableType: billableType,
            division: division,
            unbillableTimeLossThisPP: totalFieldOpearation.unbillableTimeLossThisPP + parseFloat(element.unbillableTimeLossThisPP),
            eosTimeLossthisPP: totalFieldOpearation.eosTimeLossthisPP + parseFloat(element.eosTimeLossthisPP),
            profitUnbillableAndEosthisPP:totalFieldOpearation.profitUnbillableAndEosthisPP + parseFloat(element.profitUnbillableAndEosthisPP),
        }
    },
    GetCalTest(totalFieldOpearation, element, unBillableTimePer, billableType, division) {
        // console.log('totalFieldOpearation', totalFieldOpearation.profitUnbillableAndEosthisPP,'-------',element.profitUnbillableAndEosthisPP);
        
        return {
            labourBurden: totalFieldOpearation.labourBurden + parseFloat(element.labourBurden),
            billableRate: totalFieldOpearation.billableRate + parseFloat(element.billableRate),
            profit: totalFieldOpearation.profit + parseFloat(element.profit),
            // mark_up_per: totalFieldOpearation.mark_up_per + (element.mark_up_per != null) ? parseFloat(element.mark_up_per) : 0,
            mark_up_per: totalFieldOpearation.mark_up_per +( (element.mark_up_per != null) ? parseFloat(element.mark_up_per) : 0),
            billableTime: totalFieldOpearation.billableTime + parseFloat(element.billableTime),
            unBillableTime: totalFieldOpearation.unBillableTime + parseFloat(element.unBillableTime),
            vacatiomStatTime: totalFieldOpearation.vacatiomStatTime + parseFloat(element.vacatiomStatTime),
            eosTime: totalFieldOpearation.eosTime + parseFloat(element.eosTime),
            salesTime: totalFieldOpearation.salesTime + parseFloat(element.salesTime),
            sickTime: totalFieldOpearation.sickTime + parseFloat(element.sickTime),
            totalHours: totalFieldOpearation.totalHours + parseFloat(element.totalHours),
            unBillableTimePer: totalFieldOpearation.unBillableTimePer + parseFloat(unBillableTimePer),
            profitthisPP: totalFieldOpearation.profitthisPP + parseFloat(element.profitthisPP),
            lossVsBillable: totalFieldOpearation.lossVsBillable + parseFloat(element.lossVsBillable),
            lossVsLB: totalFieldOpearation.lossVsLB + parseFloat(element.lossVsLB),
            name: '',
            billableType: billableType,
            division: division,
            unbillableTimeLossThisPP: totalFieldOpearation.unbillableTimeLossThisPP + parseFloat(element.unbillableTimeLossThisPP),
            eosTimeLossthisPP: totalFieldOpearation.eosTimeLossthisPP + parseFloat(element.eosTimeLossthisPP),
            profitUnbillableAndEosthisPP:totalFieldOpearation.profitUnbillableAndEosthisPP + parseFloat(element.profitUnbillableAndEosthisPP),
        }
    },
    getDataBilible(data) {
        var arr = [];
        var AdministrationList = [];
        var SalesList = [];
        var totalFieldOpearationMarkupPer = 0;
        var totalFieldOpearation = this.getData();
        var totalFieldOpearationGrossProfit = this.getData();

        var totalPreConstructionMarkupPer = 0;
        var totalPreConstruction = this.getData();
        var totalPreConstructionGrossProfit = this.getData();

        var totalInteriorDesignMarkupPer = 0;
        var totalInteriorDesign = this.getData();
        var totalInteriorDesignGrossProfit = this.getData();

        var totalProjectManagementMarkupPer = 0;
        var totalProjectManagement = this.getData();
        var totalProjectManagementGrossProfit = this.getData();



        var totalPropertyManagementMarkupPer = 0;
        var totalPropertyManagement = this.getData();
        var totalPropertyManagementGrossProfit = this.getData();

        var totalSalesAndMarketingMarkupPer = 0;
        var totalSalesAndMarketing = this.getData();
        var totalSalesAndMarketingGrossProfit = this.getData();


        var totalAdministrationMarkupPer = 0;
        var totalAdministration = this.getData();
        var totalAdministrationGrossProfit = this.getData();


        data.forEach(element => {
            var isAddData = false;
            var unBillableTimePer = 0;
            if (element.totalHours != 0) {
                unBillableTimePer = (parseFloat(element.unBillableTime) / parseFloat(element.totalHours)) * 100;
            }
            var billableType = '5 Property Management';
            if (element.division == "Field Operations Foreman" || element.division == "Field Operations") {
                billableType = "1 Field Operations Team Unbillable time is set at 0%";
                totalFieldOpearationMarkupPer++;
                totalFieldOpearationGrossProfit.division = "Gross Pofit/Loss"
                totalFieldOpearationGrossProfit.billableType = billableType
                var division = "Gross Pofit/Loss"
                //    var division ="Total Field Operations"
                totalFieldOpearation = this.GetCal(totalFieldOpearation, element, unBillableTimePer, billableType, division);


            }
            if (element.division == "Pre Construction Estimating"||element.division == "Pre-Construction Estimator") {
                billableType = "2 Pre Construction Team Unbillable Time is set at 10%";
                totalPreConstructionMarkupPer++;
                totalPreConstructionGrossProfit.division = "Gross Pofit/Loss"
                totalPreConstructionGrossProfit.billableType = billableType
                var division = "Gross Pofit/Loss"
                // var division ="Total Pre Con Estimating"

                totalPreConstruction = this.GetCal(totalPreConstruction, element, unBillableTimePer, billableType, division);

            }
            if (element.division == "Interior Design" || element.division == "Interior Design PS"|| element.division == "Interior Designer") {
                billableType = "3 Interior Design Team Unbillable Time is set at 10%";
                totalInteriorDesignMarkupPer++;
                totalInteriorDesignGrossProfit.division = "Gross Pofit/Loss"
                totalInteriorDesignGrossProfit.billableType = billableType
                var division = "Gross Pofit/Loss"
                // var division = "Total Interior Design"

                totalInteriorDesign = this.GetCal(totalInteriorDesign, element, unBillableTimePer, billableType, division);

            }
            if (element.division == "Project Management" || element.division == "Project Manager") {
                billableType = "4 Project Management Team Unbillable Time is set at 10%";
                totalProjectManagementMarkupPer++;
                totalProjectManagementGrossProfit.division = "Gross Pofit/Loss"
                totalProjectManagementGrossProfit.billableType = billableType
                var division = "Gross Pofit/Loss"
                // var division = "Total Project Management"

                totalProjectManagement = this.GetCal(totalProjectManagement, element, unBillableTimePer, billableType, division);


            }
            if (element.division == "Property Management") {
                billableType = "5 Property Management";


                totalPropertyManagementMarkupPer++;
                totalPropertyManagementGrossProfit.division = "Gross Pofit/Loss"
                totalPropertyManagementGrossProfit.billableType = billableType
                var division = "Total Property Management"

                totalPropertyManagement = this.GetCal(totalPropertyManagement, element, unBillableTimePer, billableType, division);
            }

            if (element.division == "VP Sales & Marketing" || element.division == "Sales PM") {
                billableType = "5 Sales & Marketing Team Unbillable Time ";
                // billableType = "5 Property Management";
                isAddData = true;


                totalSalesAndMarketingMarkupPer++;
                totalSalesAndMarketingGrossProfit.division = "Gross Pofit/Loss"
                totalSalesAndMarketingGrossProfit.billableType = billableType
                var division = "Gross Pofit/Loss"
                // var division = "Total Sales & Marketing"
                totalSalesAndMarketing = this.GetCal(totalSalesAndMarketing, element, unBillableTimePer, billableType, division);
            }
            if (element.division == "Administration"||element.division == "Admin"||element.division == "President"||element.division == "VP of Construction Operations"||element.division == "Accounting") {
                isAddData = true;
                billableType = "6 Administration Team Unbillable Time";
                // billableType = "6 Property Management";
                // billableType = "5 Property Management";

                totalAdministrationMarkupPer++;
                totalAdministrationGrossProfit.division = "Gross Pofit/Loss"
                totalAdministrationGrossProfit.billableType = billableType
                var division = "Gross Pofit/Loss Administration"
                // var division = "Total Administration"
                totalAdministration = this.GetCalTest(totalAdministration, element, unBillableTimePer, billableType, division);
            }

            var t = {
                division: element.division,
                name: element.name,
                labourBurden: parseFloat(element.labourBurden),
                billableRate: parseFloat(element.billableRate),
                profit: parseFloat(element.profit),
                mark_up_per: (element.mark_up_per != null) ? parseFloat(element.mark_up_per) : 0,
                billableTime: parseFloat(element.billableTime),
                unBillableTime: parseFloat(element.unBillableTime),
                vacatiomStatTime: parseFloat(element.vacatiomStatTime),
                eosTime: parseFloat(element.eosTime),
                salesTime: parseFloat(element.salesTime),
                sickTime: parseFloat(element.sickTime),
                totalHours: parseFloat(element.totalHours),
                unBillableTimePer: parseFloat(unBillableTimePer),
                profitthisPP: parseFloat(element.profitthisPP),
                lossVsBillable: parseFloat(element.lossVsBillable),
                lossVsLB: parseFloat(element.lossVsLB),
                billableType: billableType,
                unbillableTimeLossThisPP: parseFloat(element.unbillableTimeLossThisPP),
            eosTimeLossthisPP: parseFloat(element.eosTimeLossthisPP),
            profitUnbillableAndEosthisPP:  parseFloat(element.profitUnbillableAndEosthisPP),


            };
            if (isAddData) {

                if (element.division == "Administration") {
                    AdministrationList.push(t);
                } else {
                    SalesList.push(t);
                }
            } else {
                arr.push(t);
            }

        });

        // Field Operations Team 
        totalFieldOpearation.mark_up_per = (totalFieldOpearation.mark_up_per / totalFieldOpearationMarkupPer)
        totalFieldOpearation.unBillableTimePer = (totalFieldOpearation.unBillableTimePer / totalFieldOpearationMarkupPer)
        totalFieldOpearationGrossProfit.lossVsBillable = totalFieldOpearation.profitthisPP - totalFieldOpearation.lossVsBillable
        totalFieldOpearationGrossProfit.lossVsLB = totalFieldOpearation.profitthisPP - totalFieldOpearation.lossVsLB
        arr.push(totalFieldOpearation);
        // ----- total Field Opearation Gross Profit------
        //  arr.push(totalFieldOpearationGrossProfit);

        // Pre Construction Team 
        totalPreConstruction.mark_up_per = (totalPreConstruction.mark_up_per / totalPreConstructionMarkupPer)
        totalPreConstruction.unBillableTimePer = (totalPreConstruction.unBillableTimePer / totalPreConstructionMarkupPer)
        totalPreConstructionGrossProfit.lossVsBillable = totalPreConstruction.profitthisPP - totalPreConstruction.lossVsBillable
        totalPreConstructionGrossProfit.lossVsLB = totalPreConstruction.profitthisPP - totalPreConstruction.lossVsLB
        arr.push(totalPreConstruction);
        // -----total PreConstruction Gross Profit ------
        // arr.push(totalPreConstructionGrossProfit);

        // Interior Design 
        totalInteriorDesign.mark_up_per = (totalInteriorDesign.mark_up_per / totalInteriorDesignMarkupPer)
        totalInteriorDesign.unBillableTimePer = (totalInteriorDesign.unBillableTimePer / totalInteriorDesignMarkupPer)
        totalInteriorDesignGrossProfit.lossVsBillable = totalInteriorDesign.profitthisPP - totalInteriorDesign.lossVsBillable
        totalInteriorDesignGrossProfit.lossVsLB = totalInteriorDesign.profitthisPP - totalInteriorDesign.lossVsLB
        arr.push(totalInteriorDesign);
        //--- Total Interior Design Gross Profit ---
        // arr.push(totalInteriorDesignGrossProfit);
        // Project Management
        totalProjectManagement.mark_up_per = (totalProjectManagement.mark_up_per / totalProjectManagementMarkupPer)
        totalProjectManagement.unBillableTimePer = (totalProjectManagement.unBillableTimePer / totalProjectManagementMarkupPer)
        totalProjectManagementGrossProfit.lossVsBillable = totalProjectManagement.profitthisPP - totalProjectManagement.lossVsBillable
        totalProjectManagementGrossProfit.lossVsLB = totalProjectManagement.profitthisPP - totalProjectManagement.lossVsLB
        arr.push(totalProjectManagement);
        // Total Project Management
        // arr.push(totalProjectManagementGrossProfit);
        // Gross Pofit/Loss Field Ops, Pre Con, ID, & PM's

        var grossPofitLossFieldOpsPreConIdAndPm =   this.getData();
        grossPofitLossFieldOpsPreConIdAndPm.billableType = '4 Project Management Team Unbillable Time is set at 10%';
        grossPofitLossFieldOpsPreConIdAndPm.division = 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s';

        grossPofitLossFieldOpsPreConIdAndPm.salesTime = totalFieldOpearation.salesTime+totalPreConstruction.salesTime+totalInteriorDesign.salesTime+totalProjectManagement.salesTime;
        grossPofitLossFieldOpsPreConIdAndPm.sickTime = totalFieldOpearation.sickTime+totalPreConstruction.sickTime+totalInteriorDesign.sickTime+totalProjectManagement.sickTime;
        grossPofitLossFieldOpsPreConIdAndPm.profitthisPP = totalFieldOpearation.profitthisPP+totalPreConstruction.profitthisPP+totalInteriorDesign.profitthisPP+totalProjectManagement.profitthisPP;
        grossPofitLossFieldOpsPreConIdAndPm.unbillableTimeLossThisPP = totalFieldOpearation.unbillableTimeLossThisPP+totalPreConstruction.unbillableTimeLossThisPP+totalInteriorDesign.unbillableTimeLossThisPP+totalProjectManagement.unbillableTimeLossThisPP;
        grossPofitLossFieldOpsPreConIdAndPm.eosTimeLossthisPP = totalFieldOpearation.eosTimeLossthisPP+totalPreConstruction.eosTimeLossthisPP+totalInteriorDesign.eosTimeLossthisPP+totalProjectManagement.eosTimeLossthisPP;
        grossPofitLossFieldOpsPreConIdAndPm.profitUnbillableAndEosthisPP = totalFieldOpearation.profitUnbillableAndEosthisPP+totalPreConstruction.profitUnbillableAndEosthisPP+totalInteriorDesign.profitUnbillableAndEosthisPP+totalProjectManagement.profitUnbillableAndEosthisPP;
        arr.push(grossPofitLossFieldOpsPreConIdAndPm);

        
      



        // Property Management
        totalPropertyManagement.mark_up_per = (totalPropertyManagement.mark_up_per / totalPropertyManagementMarkupPer)
        totalPropertyManagement.unBillableTimePer = (totalPropertyManagement.unBillableTimePer / totalPropertyManagementMarkupPer)
        totalPropertyManagementGrossProfit.lossVsBillable = totalPropertyManagement.profitthisPP - totalPropertyManagement.lossVsBillable
        totalPropertyManagementGrossProfit.lossVsLB = totalPropertyManagement.profitthisPP - totalPropertyManagement.lossVsLB
        // arr.push(totalPropertyManagement);
        // arr.push(totalPropertyManagementGrossProfit);

        // Total Field ops/ID/PM/Pre Con
        var TotalFieldopsIDPMPreCon = this.getData();
        var TotalFieldopsIDPMPreConGrossProfit = this.getData();

        TotalFieldopsIDPMPreCon.division = "Total Field ops/ID/PM/Pre Con";
        TotalFieldopsIDPMPreCon.billableType = "6 Property Management";
        TotalFieldopsIDPMPreConGrossProfit.division = "Gross Pofit/Loss";
        TotalFieldopsIDPMPreConGrossProfit.billableType = "6 Property Management";

        TotalFieldopsIDPMPreCon.profitthisPP = totalFieldOpearation.profitthisPP + totalPreConstruction.profitthisPP + totalInteriorDesign.profitthisPP + totalProjectManagement.profitthisPP;

        TotalFieldopsIDPMPreCon.lossVsBillable = totalFieldOpearation.lossVsBillable + totalPreConstruction.lossVsBillable + totalInteriorDesign.lossVsBillable + totalProjectManagement.lossVsBillable;

        TotalFieldopsIDPMPreCon.lossVsLB = totalFieldOpearation.lossVsLB + totalPreConstruction.lossVsLB + totalInteriorDesign.lossVsLB + totalProjectManagement.lossVsLB;

        TotalFieldopsIDPMPreConGrossProfit.lossVsBillable = TotalFieldopsIDPMPreCon.profitthisPP - TotalFieldopsIDPMPreCon.lossVsBillable;
        TotalFieldopsIDPMPreConGrossProfit.lossVsLB = TotalFieldopsIDPMPreCon.profitthisPP - TotalFieldopsIDPMPreCon.lossVsLB;
        // arr.push(TotalFieldopsIDPMPreCon);
        // arr.push(TotalFieldopsIDPMPreConGrossProfit);

        // Total Sales & Marketing
      
        // arr.concat(SalesList);
        SalesList.forEach(element => {
            arr.push(element);
        });
        // [...arr, ...SalesList];
        totalSalesAndMarketing.mark_up_per = (totalSalesAndMarketing.mark_up_per / totalSalesAndMarketingMarkupPer)
        totalSalesAndMarketing.unBillableTimePer = (totalSalesAndMarketing.unBillableTimePer / totalSalesAndMarketingMarkupPer)
        totalSalesAndMarketingGrossProfit.lossVsBillable = totalSalesAndMarketing.profitthisPP - totalSalesAndMarketing.lossVsBillable
        totalSalesAndMarketingGrossProfit.lossVsLB = totalSalesAndMarketing.profitthisPP - totalSalesAndMarketing.lossVsLB
        arr.push(totalSalesAndMarketing);
        // arr.push(totalSalesAndMarketingGrossProfit);

        // Total Administration
        AdministrationList.forEach(element => {
            arr.push(element);
        });
        totalAdministration.mark_up_per = (totalAdministration.mark_up_per / totalAdministrationMarkupPer)
        totalAdministration.unBillableTimePer = (totalAdministration.unBillableTimePer / totalAdministrationMarkupPer)
        totalAdministrationGrossProfit.lossVsBillable = totalAdministration.profitthisPP - totalAdministration.lossVsBillable
        totalAdministrationGrossProfit.lossVsLB = totalAdministration.profitthisPP - totalAdministration.lossVsLB
        arr.push(totalAdministration);
        // arr.push(totalAdministrationGrossProfit);

        // Total labour burden billable vs unbillalbe Gross Profit or Loss
        var Total79 = this.getData();
        var TotalFiel80 = this.getData();

        Total79.division = "Gross Profit/Loss";
        Total79.billableType = "5 Property Management";
        TotalFiel80.division = "Total labour burden billable vs unbillalbe Gross Profit or Loss";
        TotalFiel80.billableType = "5 Property Management";

        Total79.labourBurden = totalFieldOpearation.labourBurden + totalPreConstruction.labourBurden + totalInteriorDesign.labourBurden + totalProjectManagement.labourBurden + totalSalesAndMarketing.labourBurden + totalAdministration.labourBurden;

        Total79.profitthisPP = totalFieldOpearation.profitthisPP + totalPreConstruction.profitthisPP + totalInteriorDesign.profitthisPP + totalProjectManagement.profitthisPP + totalSalesAndMarketing.profitthisPP + totalAdministration.profitthisPP;

        Total79.lossVsBillable = totalFieldOpearation.lossVsBillable + totalPreConstruction.lossVsBillable + totalInteriorDesign.lossVsBillable + totalProjectManagement.lossVsBillable + totalSalesAndMarketing.lossVsBillable + totalAdministration.lossVsBillable;


        TotalFiel80.lossVsBillable = Total79.profitthisPP - Total79.lossVsBillable;

        TotalFiel80.lossVsLB = totalFieldOpearationGrossProfit.lossVsLB + totalPreConstructionGrossProfit.lossVsLB + totalInteriorDesignGrossProfit.lossVsLB + totalProjectManagementGrossProfit.lossVsLB + totalSalesAndMarketingGrossProfit.lossVsLB + totalAdministrationGrossProfit.lossVsLB;


        // arr.push(Total79);
        // arr.push(TotalFiel80);
        // LIDA Construction Gross Pofit/Loss 
// 
            var LIDAConstructionGrossPofitByLoss = this.getData();
            LIDAConstructionGrossPofitByLoss.billableType = "6 Administration Team Unbillable Time"
            LIDAConstructionGrossPofitByLoss.division = "LIDA Construction Gross Pofit/Loss"
            LIDAConstructionGrossPofitByLoss.profitthisPP = grossPofitLossFieldOpsPreConIdAndPm.profitthisPP+totalSalesAndMarketing.profitthisPP+totalAdministration.profitthisPP;

            LIDAConstructionGrossPofitByLoss.unbillableTimeLossThisPP = grossPofitLossFieldOpsPreConIdAndPm.unbillableTimeLossThisPP+totalSalesAndMarketing.unbillableTimeLossThisPP+totalAdministration.unbillableTimeLossThisPP;
            LIDAConstructionGrossPofitByLoss.eosTimeLossthisPP = grossPofitLossFieldOpsPreConIdAndPm.eosTimeLossthisPP+totalSalesAndMarketing.eosTimeLossthisPP+totalAdministration.eosTimeLossthisPP;



            // console.log('-',grossPofitLossFieldOpsPreConIdAndPm.profitUnbillableAndEosthisPP,'-',totalSalesAndMarketing.profitUnbillableAndEosthisPP,'-',totalAdministration.profitUnbillableAndEosthisPP);

            
            LIDAConstructionGrossPofitByLoss.profitUnbillableAndEosthisPP = grossPofitLossFieldOpsPreConIdAndPm.profitUnbillableAndEosthisPP+totalSalesAndMarketing.profitUnbillableAndEosthisPP+totalAdministration.profitUnbillableAndEosthisPP;
            arr.push(LIDAConstructionGrossPofitByLoss)




        return arr.filter((row) => this.isRenderableRow(row));


    },
    getBillableColumnData() {
        return [
            {
                name: "Division",
                value: 'division'
            },
            {
                name: "Name",
                value: 'name'
            },
            {
                name: "Labour Burden",
                value: 'labourBurden'
            },
            {
                name: "Billable Rate",
                value: 'billableRate'
            },
            {
                name: "Profit $",
                value: 'profit'
            },
            {
                name: "Mark up %",
                value: 'mark_up_per'
            },

            {
                name: "Billable Time",
                value: 'billableTime'
            },
            {
                name: "Unbillable Time",
                value: 'unBillableTime'
            },
            {
                name: "Vacation/Stat Time",
                value: 'vacatiomStatTime'
            },
            {
                name: "EOS Time",
                value: 'eosTime'
            },
            {
                name: "Sales Time",
                value: 'salesTime'
            },
            {
                name: "Sick Time",
                value: 'sickTime'
            },
            {
                name: "Total Hours",
                value: 'totalHours'
            },
            {
                name: "% Unbillable Time",
                value: 'unBillableTimePer'
            },
            {
                name: "Profit / PP",
                value: 'profitthisPP'
            },
            // {
            //     name: "Loss Vs Billable",
            //     value: 'lossVsBillable'
            // },
            // {
            //     name: "Loss Vs LB",
            //     value: 'lossVsLB'
            // },
             {
                name: "Unbillable Time Loss this PP to the Company",
                value: 'unbillableTimeLossThisPP'
            }, 
            {
                name: "EOS Time Loss this PP to the Company",
                value: 'eosTimeLossthisPP'
            },
             {
                name: "Profit - Unbillable & EOS this PP to the Company",
                value: 'profitUnbillableAndEosthisPP'
            },
        ]

    },
    getMonthAndYearList() {
        const years = [
            { year: '2020', },
            { year: '2021', },
            { year: '2022', },
            { year: '2023', },
            { year: '2025', },
            { year: '2026', },
            { year: '2027', },
            { year: '2028', },
            { year: '2029', },
            { year: '2030', },
        ];

        const months = [
            { month: 'Jan' },
            { month: 'Feb' },
            { month: 'Mar' },
            { month: 'Apr' },
            { month: 'May' },
            { month: 'Jun' },
            { month: 'Jul' },
            { month: 'Aug' },
            { month: 'Sep' },
            { month: 'Oct' },
            { month: 'Nov' },
            { month: 'Dec' },

        ];
        return {
            years: years,
            months: months
        }
    },

}